// extracted by mini-css-extract-plugin
var _1 = "ViewingApplicantPreviewViewing-moduleViewingApplicantPreviewViewing__ehCHU ViewingApplicantPreviewSection-modulerows__np1Dk";
var _2 = "ViewingApplicantPreviewViewing-modulelabel___9_wc ViewingApplicantPreviewSection-modulerowLabel__i5FNL";
var _3 = "ViewingApplicantPreviewViewing-modulestatus__KsEDA ViewingApplicantPreviewSection-modulerowStatus__Sqa2S";
var _4 = "ViewingApplicantPreviewViewing-modulevalue__lkSn2 ViewingApplicantPreviewSection-modulerowValue__rmHea";
export { _1 as "ViewingApplicantPreviewViewing", _2 as "label", _3 as "status", _4 as "value" }
